import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { OutboundLink } from 'react-ga'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import styles from '../styles/Card.module.scss'
import { useSelector } from 'react-redux'
import { v4 } from 'uuid'

const CardPrices = ({ prices }) => {
  const tcgplayerKickback = useSelector((state) => state.misc.tcgplayerKickback)
  const tcgplayerSale = useSelector((state) => state.misc.tcgplayerSale)
  const firebasePriceSources = useSelector(
    (state) => state.firebase.profile.priceSources
  )
  const localPriceSources = useSelector((state) => state.settings.priceSources)
  const priceSources = firebasePriceSources || localPriceSources

  const priceLinks = {
    cardhoarder: () => (
      <OutboundLink
        alt='Buy at Cardhoarder'
        eventLabel={prices.cardhoarder.url}
        key={v4()}
        target='_blank'
        title='Buy at Cardhoarder'
        to={prices.cardhoarder.url}
      >
        <div className={styles.price}>
          <span>{`${prices.cardhoarder.price} TIX`}</span>
        </div>
      </OutboundLink>
    ),
    cardkingdom: () => (
      <OutboundLink
        alt='Buy at Card Kingdom'
        eventLabel={`${prices.cardkingdom.url}&partner_args=edhrec`}
        key={v4()}
        target='_blank'
        title='Buy at Card Kingdom'
        to={`${prices.cardkingdom.url}&partner_args=edhrec`}
      >
        <div className={styles.price}>
          <svg
            height='12'
            version='1.1'
            viewBox='0 0 3.7041667 3.1750001'
            width='14'
            xmlns='http://www.w3.org/2000/svg'
          >
            <g transform='translate(0 -293.82)'>
              <path d='m0 293.82v1.1592h0.52042v2.0158h2.6633v-2.0158h0.52042v-1.1592h-0.57636v1.0908h-0.49196v-1.084h-0.54839v1.084h-0.47074v-1.084h-0.54839v1.084h-0.49196v-1.0908z' />
            </g>
          </svg>
          <span>{`$${prices.cardkingdom.price.toFixed(2)}`}</span>
        </div>
      </OutboundLink>
    ),
    cardmarket: () => (
      <OutboundLink
        alt='Buy at Cardmarket'
        eventLabel={prices.cardmarket.url}
        key={v4()}
        rel='nofollow'
        target='_blank'
        title='Buy at Cardmarket'
        to={`${prices.cardmarket.url}?utm_source=edhrec&utm_medium=text&utm_campaign=card_prices`}
      >
        <div className={styles.price}>
          <span>
            {`${
              typeof prices.cardmarket.price === 'number'
                ? prices.cardmarket.price.toFixed(2)
                : prices.cardmarket.price
            } €`.replace('.', ',')}
          </span>
        </div>
      </OutboundLink>
    ),
    /* mtgstocks: () => (
      <OutboundLink
        alt='View on MTGStocks'
        eventLabel={prices.mtgstocks.url}
        key={v4()}
        rel='nofollow'
        target='_blank'
        title='View on MTGStocks'
        to={prices.mtgstocks.url}
      >
        <div className={styles.price}>
          <span>📈${prices.mtgstocks.price.toFixed(2)}</span>
        </div>
      </OutboundLink>
    ), */
    tcgplayer: () => {
      const d = new Date(tcgplayerKickback?.end)
      const saleEndTime = `${d.getHours() % 12}:${d
        .getMinutes()
        .toString()
        .padStart(2, '0')} ${
        d.getHours() > 11 ? 'P' : 'A'
      }M ${d.toLocaleDateString()}`
      const Container = ({ children }) =>
        tcgplayerSale > 0 ? (
          <OverlayTrigger
            overlay={
              <Tooltip id='button-tooltip'>
                <div>On Sale Until</div>
                <div>{saleEndTime}</div>
              </Tooltip>
            }
            placement='top'
          >
            {children}
          </OverlayTrigger>
        ) : (
          children
        )
      return (
        <Container key={v4()}>
          <OutboundLink
            alt='Buy at TCGplayer'
            eventLabel={prices.tcgplayer.url}
            target='_blank'
            title='Buy at TCGplayer'
            to={prices.tcgplayer.url}
          >
            <div className={styles.price}>
              <svg
                aria-hidden='true'
                className=''
                focusable='false'
                height='12'
                version='1.1'
                viewBox='0 0 10.399999 12'
                width='10.4'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='m4.22 0.8h-2.5536c-0.4496 0-0.8 0.3576-0.8 0.8v8.8c0 0.4424 0.3584 0.8 0.8 0.8h7.0672c0.4496 0 0.8-0.3576 0.8-0.8v-8.8c9e-7 -0.4424-0.3584-0.8-0.8-0.8h-1.4896l0.5472 2.52c0.025596 0.0768-0.00804 0.14-0.1008 0.188-0.0672 0.0352-0.1472 0.0528-0.24 0.0528-0.041604 0-0.072 0-0.092796-4e-3l-2.2712 0.9552 0.656 3.2432c0.020004 0.051204 0.00804 0.099204-0.036 0.144-0.0432 0.044796-0.1096 0.075204-0.1968 0.0912-0.051996 0.00636-0.087996 0.0096-0.108 0.0096-0.1496 0-0.2584-0.039996-0.3256-0.12l-2.444-3.9624c-0.056-0.0776-0.0384-0.148 0.0544-0.212 0.0776-0.048 0.1648-0.072 0.264-0.072 0.02 0 0.0504 0.0032 0.092 0.0096l2.1968-1.128-1.02-1.7152zm-4.22 0.005604c0-0.4456 0.3576-0.8056 0.8-0.8056h8.8c0.4424 0 0.8 0.36 0.8 0.8056v10.389c0 0.4456-0.3576 0.8056-0.8 0.8056h-8.8c-0.4424 0-0.8-0.36-0.8-0.8056z'
                  fillRule='evenodd'
                  strokeWidth='.8'
                />
              </svg>
              <span>{`$${(
                ((100 - tcgplayerSale) / 100) *
                prices.tcgplayer.price
              ).toFixed(2)}`}</span>
              {tcgplayerSale > 0 && (
                <span className={styles.saleIcon}>
                  <FontAwesomeIcon icon='circle' />
                </span>
              )}
            </div>
          </OutboundLink>
        </Container>
      )
    },
  }
  return (
    <div className={styles.prices}>
      {prices && (
        <>
          {[0, 1, 2].map((i) => {
            const priceSource =
              priceSources[i] === 'coolstuffinc'
                ? 'cardhoarder'
                : priceSources[i]
            return prices[priceSource] && priceLinks[priceSource] ? (
              priceLinks[priceSource]()
            ) : (
              <span key={v4()}>&nbsp;</span>
            )
          })}
        </>
      )}
    </div>
  )
}

export default CardPrices
